import type { AppId, RoleSuggestion } from '../../types/appSuites'

export function normalizeRole(role: string): string {
  return role.trim().toLowerCase().replaceAll('_', '-').replaceAll(' ', '-')
}

/** First matching suggestion wins. Roles are compared after normalization. */
export function suggestedAppFor(
  roles: ReadonlyArray<{ name: string } | string>,
  suggestions: readonly RoleSuggestion[],
): AppId | null {
  const names = new Set(
    roles.map((role) => normalizeRole(typeof role === 'string' ? role : role.name)),
  )
  for (const suggestion of suggestions) {
    if (names.has(normalizeRole(suggestion.role))) return suggestion.app_id
  }
  return null
}
